// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"4b3e184ce1ee426b477f","293":"f8486a50ae1c9a617e0e","518":"f95d3fbc4f3d0c3f2bfd","779":"72704d8e035f718a77d5"}[chunkId] + ".js";
};